var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DnRouterLink',{attrs:{"title":"Start Claim","url":"/claimsAndReturns/createClaim"}})
}
var staticRenderFns = []

export { render, staticRenderFns }